import { ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Uuid } from 'src/utils/uuid.util';
import { UmbracoGridElement } from '../../models/umbraco-grid-element.model';

@Component({
    selector: 'layout-block-list-outlet',
    styles: [':host {display: flex; flex-direction: column; max-width: 100cqw;}'],
    templateUrl: './block-list-outlet.component.html',
})
export class BlockListOutletComponent implements OnDestroy, OnInit {
    @Input() list: UmbracoGridElement[];
    hash: number;
    constructor(public element: ElementRef) {

    }
    ngOnInit(): void {
        this.hash = BlockListOutletComponent.hashCode(JSON.stringify(this.list))
        let height = sessionStorage.getItem('BL-' + this.hash)
        if (height)
            this.element.nativeElement.style.height = height + 'px';
        setTimeout(() => {
            this.element.nativeElement.style.height = '';
        }, 1000);
    }
    ngOnDestroy(): void {
        sessionStorage.setItem('BL-' + this.hash, this.element.nativeElement.clientHeight)
    }
    static hashCode(str: string) {
        if(str == null)
            return 0;
        var hash = 0,
            i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
}
